import { index } from './utils';
import translations from '../app/translations/es';

index(translations);
